<template>
	<VerticalLayout>
		<slot />
	</VerticalLayout>
</template>

<script setup>
import VerticalLayout from '@/layouts/VerticalLayout.vue';
</script>
